<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Input, Select, Text } from '@Shelly/shelly-design-system';
	import { valueOutOfRange } from 'src/helpers/utilities';
	//Types
	import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

	export let controlOption: LocalControlOptions;
	export let errorInput = false;

	const componentTypes = ['Switch', 'Light', 'CCT', 'RGB', 'RGBW', 'RGBCCT'].map((type) => ({
		title: type,
		value: type,
	}));

	const componentId = controlOption.lnm?.componentId ?? 0;
	$: errorInput = !Number.isInteger(componentId) || valueOutOfRange(componentId, 0, 255);
</script>

<div>
	<Text class="mb-s" element="h2">
		{$format('local_action_lnm_component_type', { default: 'Set Component Type property' })}
	</Text>
	<Select
		size="m"
		value={componentTypes.find((type) => type.value === controlOption.lnm.componentType) ||
			componentTypes[0]}
		options={componentTypes}
		icon={null}
		on:change={(event) => {
			controlOption.lnm.componentType = event.detail['value'];
			controlOption = { ...controlOption };
		}}
		id="select-lnm-component-type"
		aria-label={$format('local_action_lnm_component_type', {
			default: 'Set Component Type property',
		})}
	/>
</div>

<div>
	<Text class="mb-s" element="h2">
		{$format('local_action_lnm_component_id', { default: 'Set Component ID property' })}
	</Text>
	<Input
		size="m"
		type="number"
		min="0"
		max="255"
		value={String(componentId)}
		error={errorInput
			? $format('local_action_lnm_component_id_error', {
					default: 'Component ID must be an integer between 0 and 255.',
				})
			: ''}
		on:input={(event) => {
			const value = event.target['value'];
			controlOption.lnm.componentId = value === '' ? null : Number(value);
			controlOption = { ...controlOption };
		}}
		id="input-lnm-component-id"
		aria-label={$format('local_action_lnm_component_id', {
			default: 'Set Component ID property',
		})}
	/>
</div>
